import React, { useState } from 'react'
import { Link, Redirect, useLocation } from 'react-router-dom'
import { ButtonLogin, ContainerLogin, FormContainerLogin, FormInputLogin, ImgLogo, InputLogin, TitleLogin } from '../login/style'
import { AlertError, AlertSuccess, Loadingfunc } from '../../../../component'
import { AuthService } from '../../../../service'
import { useTitle } from '../../../../util'
import logo from "../../../../asset/logo/logogram_color.svg"

export const IdxResetPassword = () => {
  useTitle('Reset Password')

  const { search } = useLocation()
  const token = new URLSearchParams(search).get('token')
  const [data, setData] = useState({ email: '', password: '', retype_password: '' })
  const [loading, setLoading] = useState(false)
  const [redirect, setRedirect] = useState(false)

  const onChangeValue = (event) => {
    setData({ ...data, [event.target.name]: event.target.value })
  }

  const submit = async (event) => {
    event.preventDefault()

    if (!token) {
      AlertError({ title: 'Error', text: 'Reset password link is invalid or incomplete.' })
      return
    }

    if (data.password !== data.retype_password) {
      AlertError({ title: 'Error', text: 'Password confirmation does not match.' })
      return
    }

    setLoading(true)
    try {
      const result = await AuthService.resetPasswordUser({
        body: { ...data, token }
      })

      if (result?.success) {
        AlertSuccess({ title: 'Success', text: result.success })
        setRedirect(true)
      } else {
        AlertError({ title: 'Error', text: result?.error || 'Unable to reset password.' })
      }
    } catch (error) {
      AlertError({
        title: 'Error',
        text: error?.response?.data?.error || error?.message || 'Unable to reset password.'
      })
    } finally {
      setLoading(false)
    }
  }

  if (redirect) return <Redirect to="/login" />

  return (
    <ContainerLogin>

      <FormContainerLogin onSubmit={submit}>
        <FormInputLogin>
          <ImgLogo src={logo} alt="Logo" />
        </FormInputLogin>
        <FormInputLogin>
          <TitleLogin>Reset Password</TitleLogin>
        </FormInputLogin>


        <FormInputLogin>
          <InputLogin type="email" name="email" placeholder="Email" value={data.email} onChange={onChangeValue} required />
        </FormInputLogin>

        <FormInputLogin>
          <InputLogin type="password" name="password" placeholder="Password" value={data.password} onChange={onChangeValue} required />
        </FormInputLogin>

        <FormInputLogin>
          <InputLogin type="password" name="retype_password" placeholder="Confirmation password" value={data.retype_password} onChange={onChangeValue} required />
        </FormInputLogin>

        <FormInputLogin>
          {loading ? <Loadingfunc /> : <ButtonLogin type="submit">Reset</ButtonLogin>}
        </FormInputLogin>

        <FormInputLogin>
          <Link to="/login">Back to login</Link>
        </FormInputLogin>

      </FormContainerLogin>
    </ContainerLogin>
  )
}
